import { TAG } from "@/components/tag/types";

export type NavLink = {
    url: string;
    name: string;
    tagVariant?: TAG;
    external?: boolean;
};
/**
 *  Decouple from mobile implementation for now. We are updating the desktop view to use icons
 *  but leaving the mobile alone
 * */

// Admins get additional links in the settings menu in addition to the user ones
export const DesktopAdminSettingsNavList = [
    {
        url: "/DeviceDebugger",
        name: "Device Debugger",
    },
    {
        url: "/AccountManager",
        name: "Account Manager",
    },
];

export const DesktopUserSettingsNavList = [
    {
        url: "/settings",
        name: "Settings",
        translationKey: "settings",
    },
    {
        url: "/export",
        name: "Data Export",
        translationKey: "data-export",
    },
];

export const AdminToolsNavList = [
    {
        url: "/DeviceDebugger",
        name: "Device Debugger",
    },
    {
        url: "/AccountManager",
        name: "Account Manager",
    },
    {
        url: "/export",
        name: "Data Export",
    },
];
